import { Anchor, Card, Container, Group, SimpleGrid, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconListDetails, IconMap } from '@tabler/icons-react';
import { useAuthStore } from '../auth/auth-store';
import { useProjectStore } from '../project/project-store';

export function DashboardPage() {
  const user = useAuthStore((s) => s.user);
  const projectId = useProjectStore((s) => s.projectId);

  return (
    <Container size="lg">
      <Stack gap="xl">
        <Stack gap={4}>
          <Title order={1}>Welcome back{user ? `, ${user.username}` : ''}.</Title>
          <Text c="dimmed">
            {projectId
              ? 'Jump into a tract or open a title run to continue where you left off.'
              : 'Pick a project in the top bar to get started.'}
          </Text>
        </Stack>

        {projectId && (
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
            <Card withBorder padding="lg">
              <Group gap="sm" mb="xs">
                <IconMap size={20} />
                <Title order={4}>Tracts</Title>
              </Group>
              <Text size="sm" c="dimmed" mb="md">
                Add or open a tract of land to build a title run for.
              </Text>
              <Anchor component={Link} to="/tracts">
                Go to Tracts &rarr;
              </Anchor>
            </Card>

            <Card withBorder padding="lg">
              <Group gap="sm" mb="xs">
                <IconListDetails size={20} />
                <Title order={4}>Title Runs</Title>
              </Group>
              <Text size="sm" c="dimmed" mb="md">
                See every run across the project, filtered by status.
              </Text>
              <Anchor component={Link} to="/title-runs">
                Go to Title Runs &rarr;
              </Anchor>
            </Card>
          </SimpleGrid>
        )}
      </Stack>
    </Container>
  );
}
